import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@apollo/client/react';
import { Box, Center, Spinner } from '@chakra-ui/react';
import { CardCarousel, CardCarouselProps } from '@src/components/sco/CardCarousel';
import { BottomControlTest } from '@src/components/sco/CardCarousel/Controls/BottomControlTest';
import { ArticleHeroCard } from '@src/components/sco/Education/ArticleLanding/ArticleHeroCard';
import { useBreakpointContext } from '@src/components/sco/utilities/BreakpointProvider';
import { gql, gqlArgs, gqlVars } from '@src/lib/gql';
import React from 'react';
type ArticleHeroProps = {
  articleType: string;
  carouselProps?: CardCarouselProps;
  keywords?: string;
  showSummaries?: boolean;
  subjectLogo?: string;
  termSlugs?: string[];
  terms?: string;
  typeSlug?: string;
  typeTitle?: string;
};
export const ArticleHero = props => {
  const $ = _c(22);
  let t0;
  if ($[0] !== props) {
    t0 = ArticleHero.queries.articles(props);
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const t1 = props.articleType || "ExpertAdvice";
  let t2;
  if ($[2] !== props.termSlugs) {
    t2 = props.termSlugs || [];
    $[2] = props.termSlugs;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== props.keywords || $[5] !== props.terms || $[6] !== t1 || $[7] !== t2) {
    t3 = {
      variables: {
        articleType: t1,
        keywords: props.keywords,
        termSlugs: t2,
        terms: props.terms
      }
    };
    $[4] = props.keywords;
    $[5] = props.terms;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const query = useQuery(t0, t3);
  useBreakpointContext();
  let t4;
  if ($[9] !== query.loading) {
    t4 = query.loading && <Center padding="10"><Spinner /></Center>;
    $[9] = query.loading;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== query.error) {
    t5 = query.error && <p>{"Error: "}{query.error.message}</p>;
    $[11] = query.error;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== props.articleType || $[14] !== props.carouselProps || $[15] !== props.termSlugs || $[16] !== query.data) {
    t6 = query.data && <CardCarousel fade={false} visibleCards={[1]} autoCycle={{
      delay: 5000,
      pauseOnHover: false
    }} controls={{
      top: false,
      bottom: BottomControlTest
    }} {...props.carouselProps}>{query.data?.articles.map(article => <ArticleHeroCard key={article.id} articleType={props.articleType} featuredImage={article.featuredImage?.url} slug={article.slug} subjectLogos={article.subjectLogos[0]?.url} subjectNames={article.subjectNames} terms={article.terms[0]?.name} termSlugs={props.termSlugs} title={article.title} />)}</CardCarousel>;
    $[13] = props.articleType;
    $[14] = props.carouselProps;
    $[15] = props.termSlugs;
    $[16] = query.data;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] !== t4 || $[19] !== t5 || $[20] !== t6) {
    t7 = <Box bgImage="linear-gradient(transparent, {colors.colorPalette.muted/50})" boxShadow="inset 0px -20px 10px -20px rgba(0, 0, 0, 0.15)" position="relative" width="full">{t4}{t5}{t6}</Box>;
    $[18] = t4;
    $[19] = t5;
    $[20] = t6;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  return t7;
};
ArticleHero.fragments = {
  Article: () => gql`
    fragment _ on Article {
      id
      title
      seoDescription
      slug
      terms {
        id
        name
        slug
        color {
          hex
        }
      }
      subjectNames
      subjectLogos {
        id
        url
      }
      featuredImage {
        id
        url
        altText
        height
        width
      }
    }
  `
};
ArticleHero.queries = {
  articles: (props: ArticleHeroProps) => {
    const vars = gqlVars({
      '$keywords: String': props.keywords,
      '$termSlugs: [String]': props.termSlugs?.length > 0,
      '$articleType: ArticleType': props.articleType
    });
    const where = gqlArgs({
      'where: ': {
        'type: $articleType': props.articleType,
        '_search: $keywords': props.keywords,
        'terms_some: { slug_in: $termSlugs }': props.termSlugs?.length > 0
      }
    });
    return gql`
        query ${vars} {
            articles(
              first: 5
              orderBy: publishedAt_DESC
              ${where}
            ) {
                id
                ${ArticleHero.fragments.Article()}
            }
        }
    `;
  }
};